export default function decodeBase64Auto(input) {
  const binary = atob(input);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));

  // First, try UTF-8
  let text = new TextDecoder('utf-8', { fatal: false }).decode(bytes);

  // Heuristic: if the string contains too many � (U+FFFD replacement chars),
  // then assume it's not UTF-8 and retry with Windows-1252
  const replacementCount = (text.match(/\uFFFD/g) || []).length;
  if (replacementCount > 0) {
    text = new TextDecoder('windows-1252').decode(bytes);
  }

  return text;
}
